import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import moment from 'moment'
import {
  List,
  Filter,
  TextField,
  useListRepository,
  useFilter,
  DatePicker
} from 'elentari'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import blacklistRepository from './blacklistRepository'
import { BlacklistBadgeStatus } from './blacklistActions'
import { formatCpfCnpj } from '../../utils/Formatter'

const BlacklistFilter = () => {
  const filter = useFilter({})

  return (
    <Filter
      {...filter}
      labels={{
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            name="cpfcnpj"
            label="CPF/CNPJ"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field fullWidth name="placa" label="Placa" component={TextField} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            component={DatePicker}
            label="Data Criação De"
            name="createdAt"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const Blacklist = props => {
  const [ability] = useAbility()

  const listHook = useListRepository({
    repository: blacklistRepository,
    defaultSort: 'createdAt desc',
    path: 'blacklist-kmm'
  })
  const listOptions = {
    defaultOrder: 'createdAt desc',
    fields: {
      id: {
        label: 'ID'
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm')
      },
      cpfcnpj: {
        label: 'CPF/CNPJ',
        format: data => formatCpfCnpj(data) || '-'
      },
      placa: {
        label: 'Placa',
        format: data => data || '-'
      },
      dataDesbloqueio: {
        label: 'Status',
        format: data =>
          data ? (
            <BlacklistBadgeStatus status="DESBLOQUEIO" label="DESBLOQUEADO" />
          ) : (
            <BlacklistBadgeStatus status="BLOQUEIO" label="BLOQUEADO" />
          )
      }
    }
  }

  const actions = getListActions(ability, listHook, 'blacklist-kmm')

  return (
    <>
      <BlacklistFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickEdit={null}
        onClickRow={item => props.history.push(`/blacklist-kmm/${item.id}`)}
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default Blacklist
